import { render, staticRenderFns } from "./ItemProductRent.vue?vue&type=template&id=31c81456&scoped=true&"
import script from "./ItemProductRent.vue?vue&type=script&lang=js&"
export * from "./ItemProductRent.vue?vue&type=script&lang=js&"
import style0 from "./ItemProductRent.vue?vue&type=style&index=0&id=31c81456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c81456",
  null
  
)

export default component.exports